<!-- <section class="head-section">
    <div class="container container-extra no-horizontal-padding">                
        <app-product-guide category="goals" [productType]="reviewTypes.TER"></app-product-guide>
    </div>
</section> -->


    <div class="container container-xl mt-50">

        <app-back-nav class="mb-20" linkText="{{ 'GOALS.BACK_TO_ASSESSMENTS' | translate }}" [link]="'/'"></app-back-nav>

        <section class="page-title">
            <h1>{{ 'GOALS.GOALS_EVALUATIONS' | translate }}</h1>
            <div class="review-period-info" *ngIf="data && data?.goalPeriod">{{ data?.goalPeriod?.reviewPeriod.name }} | {{ data?.goalPeriod?.reviewPeriod.goalsStartDate | datePlain }} - {{ data.goalPeriod.reviewPeriod.goalsEndDate | datePlain }}</div>
        </section>
        
        <mat-card class="card-light mb-4" *ngIf="data?.goalPeriod === null || data.goalPeriod.reviewPeriod == null">
            <mat-card-content class="text-subtitle">{{ 'GOALS.GOAL_SETTING_NOT_AVAILABLE' | translate }}</mat-card-content>
        </mat-card>

        <ng-container *ngIf="data?.goalPeriod">

            <!-- header -->

            <div class="goal-header">
                <mat-card class="p-24 person-card">
                    <mat-card-content class="person-block p-0">
                        <div class="name-plate">
                            <div class="top-block-height p-16">
                                <div class="person-name" fontResize [text]="data?.employee.name" [minFontSize]="14" [maxFontSize]="40">{{ data?.employee.name }}</div>
                                <div class="email">{{ data?.employee.email }}</div>
                                <div class="inactive-user-label" *ngIf="EmployeeHelper.isEmployeeInactive(data?.employee)">{{ 'EMPLOYEE.INACTIVE_USER_LABEL' | translate }}</div>
                            </div>
                            <div class="bottom-actions">
                                <button mat-flat-button [matMenuTriggerFor]="allowedStatusList?.length ? menu : null" 
                                    class="uppercase action-button"
                                    color="primary" 
                                    [disabled]="!allowChangeStatus() || EmployeeHelper.isEmployeeInactive(data?.employee)" 
                                    [ngClass]="{'noChange': !allowedStatusList?.length}" 
                                    title="{{ 'GOALS.GOAL_SETTING_STATUS' | translate }}">
                                        {{ getStatusText(data.goalPeriod.status) }} <mat-icon iconPositionEnd *ngIf="allowedStatusList?.length">arrow_drop_down</mat-icon>
                                </button>
                                <!-- #enddocregion mat-menu-trigger-for -->
                                <mat-menu #menu="matMenu">
                                    <button (click)="onGoalStatusSelect(statusCode)" *ngFor="let statusCode of allowedStatusList" mat-menu-item>
                                        {{ getStatusText(statusCode) }}
                                    </button>
                                </mat-menu>
    
                                <button mat-flat-button (click)="showInformation()" class="button-bg-alt1 uppercase action-button">{{ 'GOALS.INFO' | translate }}</button>
                                <button [disabled]="!allowSettings() || EmployeeHelper.isEmployeeInactive(data?.employee)" mat-flat-button (click)="goToSettings()" class="button-bg-alt2 uppercase action-button">{{ 'GOALS.SETTINGS' | translate }}</button>
                            </div>
                        </div>
                        <div class="side-actions" *ngIf="targetEmployeeApproval || leaderApprovals?.length > 0">
                            <div class="top-block-height">
                                
                                    <div *ngFor="let leaderApproval of leaderApprovals; index as i">
                                        <div class="leader-name">{{ leaderApproval.employeeName }}</div>
                                        <mat-slide-toggle class="text-13" [(ngModel)]="leaderApproval.isApproved" (change)="onChangeApproval(leaderApproval)" [disabled]="!isApproveChangeEnabled(leaderApproval)" [ngClass]="{'success': leaderApproval.isApproved}">
                                            <span [ngClass]="{'success': leaderApproval.isApproved}">{{ getApproveButtonText(leaderApproval) }}
                                                <ng-container *ngIf="leaderApproval.isApproved">
                                                    {{ leaderApproval.createdOn | localizedDate }}
                                                </ng-container>
                                            </span>
                                        </mat-slide-toggle>
                                        <!-- <button mat-flat-button class="uppercase" [ngClass]="{'button-bg-alt3': i == 0, 'button-bg-alt2': i == 1}" [disabled]="!isApproveChangeEnabled(leaderApproval)" (click)="onChangeApproval(leaderApproval)">{{ getApproveButtonText(leaderApproval) }}</button> -->
                                    </div>
                                
                            </div>
                            <div class="self-approval">
                                <ng-container *ngIf="targetEmployeeApproval">
                                    <div class="leader-name">{{ targetEmployeeApproval.employeeName }}</div>
                                    <mat-slide-toggle class="text-13" [(ngModel)]="targetEmployeeApproval.isApproved" (change)="onChangeApproval(targetEmployeeApproval)" [disabled]="!isApproveChangeEnabled(targetEmployeeApproval)" [ngClass]="{'success': targetEmployeeApproval.isApproved}">
                                        <span [ngClass]="{'success': targetEmployeeApproval.isApproved}">{{ getApproveButtonText(targetEmployeeApproval) }}
                                            <ng-container *ngIf="targetEmployeeApproval.isApproved">
                                                {{ targetEmployeeApproval.createdOn | localizedDate }}
                                            </ng-container>
                                        </span>
                                    </mat-slide-toggle>
                                    <!-- <button mat-flat-button class="button-bg-alt1 uppercase" [disabled]="!isApproveChangeEnabled(targetEmployeeApproval)" (click)="onChangeApproval(targetEmployeeApproval)">{{ getApproveButtonText(targetEmployeeApproval) }}</button> -->
                                </ng-container>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
    
                <mat-card class="p-16 result-card" [appResponsiveGauge]="gaugeConfig" [gauge]="mainGauge">
                    <mat-card-content class="amount-block p-0 h-full">
                        <div class="amount-panel p-24" *ngIf="!data?.goalPeriod.reviewPeriod.reviewPeriodGoalSettings?.hiddenBaseAndPerformanceAmount">
                            <div>
                                <div class="field-title">{{ 'GOALS.BASE_AMOUNT' | translate }}</div>
                                <div class="amount">
                                    <span *ngIf="data?.goalPeriod.baseAmount">{{ (data?.goalPeriod.baseAmount) | currency : (data?.goalPeriod.currencyCode ?? 'HUF') : 'symbol' : '1.0-0' }} </span>
                                    <span *ngIf="!data?.goalPeriod.baseAmount">-</span>
                                </div>
                            </div>
                            <div>
                                <div class="field-title">{{ 'GOALS.PERFORMANCE_AMOUNT' | translate }}</div>
                                <div class="amount" *ngIf="showPerformanceBasedAmount() && data?.goalPeriod.performanceBasedAmount">
                                    {{ data?.goalPeriod.performanceBasedAmount | currency : (data?.goalPeriod.currencyCode ?? 'HUF') : 'symbol' : '1.0-0' }}
                                </div>
                                <div class="amount-error alert-color" *ngIf="showPerformanceBasedAmount() && isMinExpectationNotMet">
                                    {{ 'GOALS.MINIMUM_EXPECTATION_NOT_MET' | translate }}
                                </div>
                                <div class="amount" *ngIf="!showPerformanceBasedAmount() || (!data?.goalPeriod.performanceBasedAmount && !isMinExpectationNotMet)">-</div>
                            </div>
                        </div>
                        <div class="gauge-panel">
                            <ngx-gauge #mainGauge type="full" [ngClass]="{'no-value': !showTotalPercent() }"
                                    [value]="goalsGaugeValue | number: '1.0-0'" 
                                    label=""
                                    [thick]="8"
                                    foregroundColor="#17A5E3"
                                    append="%">
                            </ngx-gauge>
                        </div>
                    </mat-card-content>
                </mat-card>
                <!-- <mat-card class="result-card">
                    <mat-card-content>
                        
                    </mat-card-content>
                </mat-card> -->
                <app-goal-checklist [goalPeriod]="data.goalPeriod"></app-goal-checklist>
            </div>

            <app-step-indicator class="mb-4" [items]="indicatorItems" [selected]="data.goalPeriod.status" [isComplete]="isCompleted"></app-step-indicator>
    
            <!-- content -->

            <app-goal-panel *ngIf="data.goalPeriod.reviewPeriod.reviewPeriodGoalSettings.isTextBasedGoalsEnabled" [title]="data.goalPeriod.reviewPeriod.reviewPeriodGoalSettings.textBasedGoalsBlockName"                     [panelType]="goalPanelTypes.TextBasedGoals"      [goalPeriod]="data.goalPeriod"></app-goal-panel>
            <app-goal-panel *ngIf="data.goalPeriod.reviewPeriod.reviewPeriodGoalSettings.isNumericGoalsEnabled" [title]="data.goalPeriod.reviewPeriod.reviewPeriodGoalSettings.numericGoalsBlockName"                       [panelType]="goalPanelTypes.NumericGoals"        [goalPeriod]="data.goalPeriod"></app-goal-panel>

             <ng-container *ngIf="data.goalPeriod.panoramaResults?.length > 0">
                 <app-goal-panel [title]="'GOALS.360_EVALUATION_RESULT' | translate"              [panelType]="goalPanelTypes.CompetencyResult"    [goalPeriod]="data.goalPeriod"></app-goal-panel>
            </ng-container>

            <ng-container *ngFor="let item of data.goalPeriod.reviewPeriodCustomGoals; let i = index">
                <app-goal-panel [title]="item.name" [panelType]="goalPanelTypes.CustomGoals"          [goalPeriod]="data.goalPeriod" [reviewPeriodCustomGoal]="item"></app-goal-panel>
            </ng-container>

            <ng-container *ngIf="showGroupGoals">
                <app-goal-panel [title]="'GOALS.TEXT_BASED_TEAM_GOALS' | translate" [subtitle]="'GOALS.TEAM_GOALS_SUBTITLE' | translate"                                    [panelType]="goalPanelTypes.GroupGoals"               [goalPeriod]="data.goalPeriod"></app-goal-panel>
            </ng-container>
           
        </ng-container>


    </div>
